// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2mKD9","icon":"SortAdornment_icon__37Ni_","up":"SortAdornment_up__2ckMd","down":"SortAdornment_down__21wfN","active":"SortAdornment_active__1SwDu"};